import React, { useState } from 'react';
import { Form, Button } from 'reactstrap';
import FormInput from '../../../../components/UI/Input/FormInput';
import { useIsJuryVisible } from '../../../../store/configStore';
import styles from './RequestOTP.module.scss';

/**
 * RequestOTP - Screen for requesting OTP code via email
 */
function RequestOTP({ onOTPRequested, loading, countdown, initialEmail = '', onEmailChange }) {
    const isJuryVisible = useIsJuryVisible();
    const [email, setEmail] = useState(initialEmail);
    const [isValid, setIsValid] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!isJuryVisible) return;

        if (!email.trim()) {
            setIsValid(false);
            setErrorMessage('Bitte geben Sie Ihre E-Mail-Adresse ein.');
            return;
        }

        if (!validateEmail(email)) {
            setIsValid(false);
            setErrorMessage('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
            return;
        }

        setIsValid(true);
        setErrorMessage('');
        onOTPRequested(email);
    };

    const handleEmailChange = (e) => {
        const val = e.target.value;
        setEmail(val);
        if (onEmailChange) onEmailChange(val);

        if (errorMessage) {
            setIsValid(true);
            setErrorMessage('');
        }
    };

    return (
        <div>
            <div className="text-center mb-4">
                <h1 className="h2 text-primary mb-3">Herzlich willkommen zum Jury-Voting!</h1>
                {!isJuryVisible ? (
                    <div className={`alert alert-info py-3 shadow-sm border-0 ${styles.NotStartedAlert}`}>
                        <p className="mb-0 fw-bold">Das Jury-Voting hat noch nicht begonnen.</p>
                        <p className="mb-0 small opacity-75">
                            Sobald dieses startet, können Sie sich hier mit Ihrer E-Mail-Adresse anmelden.
                        </p>
                    </div>
                ) : (
                    <p className="text-muted">
                        Um fortzufahren, geben Sie bitte Ihre E-Mail-Adresse ein. Wir senden Ihnen anschließend ein{' '}
                        <strong>Einmalpasswort</strong> zur sicheren Anmeldung zu.
                    </p>
                )}
            </div>

            <Form onSubmit={handleSubmit}>
                <FormInput
                    elementType="input"
                    elementConfig={{
                        label: 'E-Mail-Adresse',
                        type: 'email',
                        placeholder: 'max.mustermann@beispiel.de',
                        autoComplete: 'email',
                        autoFocus: true,
                        columns: 12,
                        disabled: !isJuryVisible,
                    }}
                    id="jury-email"
                    name="email"
                    value={email}
                    changed={handleEmailChange}
                    invalid={!isValid}
                    errorMessage={errorMessage}
                    touched={true}
                    shouldValidate={true}
                />

                <div className="mt-2 align-content-center justify-content-center d-flex">
                    <Button type="submit" color="secondary" disabled={loading || !isJuryVisible || countdown > 0}>
                        {loading
                            ? 'Wird gesendet…'
                            : countdown > 0
                              ? `Bitte warten (${countdown}s)`
                              : 'Einmalpasswort anfordern'}
                    </Button>
                </div>
            </Form>
        </div>
    );
}

export default RequestOTP;
